import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../css/Pages.css';

const LecturerArticleDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { detailData } = location.state || {};

    React.useEffect(() => {
        if (!detailData) {
            navigate('/thong-ke-bai-bao-giang-vien');
        }
    }, [detailData, navigate]);

    const aggregatedData = useMemo(() => {
        if (!detailData || !detailData.articlesList) return [];

        let statsMap = new Map();

        detailData.articlesList.forEach(article => {
            const jType = article.JournalType || article.JournalTypeName || 'Khác';
            const jCat = article.JournalCategory || '';
            const aType = article.ArticleTypeName || 'Bài báo';
            const key = `${jType}|${jCat}|${aType}`;

            if (!statsMap.has(key)) {
                statsMap.set(key, { journalType: jType, journalCategory: jCat, articleType: aType, count: 0 });
            }
            statsMap.get(key).count += 1;
        });

        return Array.from(statsMap.values()).sort((a, b) => a.journalType.localeCompare(b.journalType));
    }, [detailData]);

    if (!detailData) return null;

    return (
        <div className="page-container" style={{ padding: '20px' }}>
            <div className="page-header" style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '15px' }}>
                <button
                    className="btn-cancel"
                    onClick={() => navigate(-1)}
                    style={{
                        background: '#0000008b',
                        color: '#fff',
                        border: 'none',
                        padding: '8px 15px',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    <i className="fa-solid fa-arrow-left" style={{ marginRight: '5px' }}></i> Quay lại
                </button>
                <h2 style={{ textTransform: 'uppercase', margin: 0 }}>Chi tiết bài báo: {detailData.fullName}</h2>
            </div>

            <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', marginBottom: '20px' }}>
                <p><strong>Đơn vị:</strong> {detailData.departmentName}</p>
                <p><strong>Email:</strong> {detailData.email}</p>
            </div>

            <div style={{ backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', overflowX: 'auto' }}>
                <table className="custom-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '800px', margin: 0 }}>
                    <thead style={{ backgroundColor: '#f4f6f9', borderBottom: '2px solid #ddd' }}>
                        <tr>
                            <th style={thStyle}>STT</th>
                            <th style={{ ...thStyle, textAlign: 'left' }}>LOẠI TẠP CHÍ</th>
                            <th style={{ ...thStyle, textAlign: 'left' }}>DANH MỤC</th>
                            <th style={{ ...thStyle, textAlign: 'left' }}>LOẠI BÀI BÁO</th>
                            <th style={thStyle}>SỐ LƯỢNG</th>
                        </tr>
                    </thead>
                    <tbody>
                        {aggregatedData.map((item, index) => (
                            <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={tdStyle}>{index + 1}</td>
                                <td style={{ ...tdStyle, textAlign: 'left' }}>{item.journalType}</td>
                                <td style={{ ...tdStyle, textAlign: 'left' }}>{item.journalCategory}</td>
                                <td style={{ ...tdStyle, textAlign: 'left' }}>{item.articleType}</td>
                                <td style={{ ...tdStyle, fontWeight: 'bold', color: '#1a56db' }}>{item.count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const thStyle = { padding: '15px 12px', textAlign: 'center', color: '#1a56db', fontSize: '13px', fontWeight: 'bold' };
const tdStyle = { padding: '15px 12px', textAlign: 'center', fontSize: '13px', color: '#333' };

export default LecturerArticleDetail;